<template>
  <div class="courseware-list">
    <div
      class="list-item"
      :style="`padding-left: ${padding}px`"
      v-for="el in info"
      :key="el.id"
    >
      <!-- <VIconFont :type="typeList[el.coursewareType].icon" class="icon" /> -->
      <icon-font :type="typeList[el.attmType].icon" class="icon" />
      <span>{{ el.attmName }}</span>
    </div>
  </div>
</template>

<script>
import iconFont from "@/components/iconFont";
export default {
  components: {
    iconFont,
  },
  props: {
    padding: {
      type: Number,
      default: 46,
    },
    info: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      typeList: [
        {},
        {
          title: "文档",
          icon: "icon-doc",
          type: "1",
        },
        {
          title: "图片",
          icon: "icon-tupian",
          type: "2",
        },
        {
          title: "视频",
          icon: "icon-shipin_n",
          type: "3",
        },
        {
          title: "音频",
          icon: "icon-yinpin",
          type: "4",
        },

        {
          title: "资源",
          icon: "icon-ziyuan",
          type: "5",
        },
        {
          title: "文档",
          icon: "icon-pdf",
          type: "6",
        },
        {
          title: "文档",
          icon: "icon-ppt",
          type: "7",
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.courseware-list {
  .list-item {
    height: 48px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #262626;
    line-height: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    .icon {
      color: #c9d0d6;
      margin-right: 8px;
    }
    &:hover {
      color: #ea0b06;
      background: #fff6ef;
      .icon {
        color: #ea0b06;
      }
    }
  }
}
</style>
